var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("kiswe-timer kiswe-timer--theme-" + _vm.theme)},[_vm._t("default"),_c('span',{staticClass:"kiswe-timer__time",attrs:{"data-qa":"text-kiswe-timer"}},[_vm._v(_vm._s(_vm.time))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }